<template>
  <div id="upload">
    <div v-if="uploadType === 'button'">
      <div>
        <el-upload
          class="upload-wrapper"
          :action="interfaceAddress"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadFail"
          :before-upload="handleBeforeUpload"
          :headers="headers"
          :show-file-list="false"
        >
          <div class="upload-btn">
            <i class="el-icon-upload2"></i>
            上传文件
          </div>
          <div slot="tip" class="el-upload__tip">{{ tips }}</div>
        </el-upload>
      </div>
      <div class="file" v-if="fileAddress !== ''">
        <i class="el-icon-paperclip"></i>
        <a :href="fileAddress" target="_blank">{{ fileName }}</a>
      </div>
    </div>
    <div class="idcard" v-if="uploadType === 'backgroundImage'">
      <el-upload
        class="upload-wrapper"
        :action="interfaceAddress"
        :on-success="handleUploadSuccess"
        :before-upload="handleBeforeUpload"
        :headers="headers"
        :show-file-list="false"
      >
        <img
          :src="
            idcardFrontAddress !== ''
              ? idcardFrontAddress
              : idcardFrontBackground
          "
          alt=""
          @click="handleClickUploadImg('front')"
        />
      </el-upload>
      <el-upload
        class="upload-wrapper"
        :action="interfaceAddress"
        :on-success="handleUploadSuccess"
        :before-upload="handleBeforeUpload"
        :headers="headers"
        :show-file-list="false"
      >
        <img
          :src="
            idcardTheBackAddress !== ''
              ? idcardTheBackAddress
              : idcardTheBackBackground
          "
          alt=""
          @click="handleClickUploadImg('theback')"
        />
      </el-upload>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["uploadCallback"],
  props: ["tips", "uploadType", "validation", "prop", "file", "parentRef"],
  data() {
    return {
      idcardFrontBackground: require("../../../assets/front.jpg"),
      idcardTheBackBackground: require("../../../assets/theback.jpg"),
      headers: {
        token: localStorage.getItem("token"),
      },
      interfaceAddress: "",
      fileName: "",
      fileAddress: "",
      idcardFrontAddress: "",
      idcardTheBackAddress: "",
      idcardSurface: "",
    };
  },
  created() {
    if (this.validation.fileName) {
      this.fileName = this.validation.fileName;
    }
    if (this.file) {
      if (typeof this.file === "object") {
        this.idcardFrontAddress = this.file[0];
        this.idcardTheBackAddress = this.file[1];
      } else {
        this.fileAddress = this.file;
      }
    }
  },
  methods: {
    handleBeforeUpload(file) {
      return new Promise((resolve) => {
        let format = this.validation.format;
        if (
          file.type === "image/png" ||
          file.type === "image/jpeg" ||
          file.type === "image/webp" ||
          file.type === "application/postscript"
        ) {
          if (file.size >= 1024 * 1024 * 10) {
            this.$message.error("上传图片大小不可超过10M！");
            return false;
          }
        } else if (
          file.type === "application/pdf" ||
          file.type === "application/zip" ||
          file.type === "application/x-rar-compressed" ||
          file.type === "application/x-7z-compressed" ||
          file.type === "application/x-tar" ||
          file.type === "application/x-gzip" ||
          file.type === "application/x-bzip2"
        ) {
          if (file.size >= 1024 * 1024 * 100) {
            this.$message.error("上传文件大小不可超过100M！");
            return false;
          }
        }
        if (format === "imageText") {
          if (
            file.type === "image/png" ||
            file.type === "image/jpeg" ||
            file.type === "image/webp"
          ) {
            this.interfaceAddress = "/declare/Upload/image";
            resolve();
          } else if (file.type === "application/pdf") {
            this.interfaceAddress = "/declare/Upload/upfile";
            resolve();
          } else {
            this.$message.error("请上传jpg、png或pdf格式的文件！");
            return false;
          }
        } else if (format === "pdf") {
          if (file.type !== "application/pdf") {
            this.$message.error("请上传pdf格式的文件！");
            return false;
          }
          this.interfaceAddress = "/declare/Upload/upfile";
          resolve();
        } else if (format === "AI") {
          if (
            file.type !== "application/postscript" &&
            file.type !== "image/png" &&
            file.type !== "image/jpeg" &&
            file.type !== "image/webp"
          ) {
            this.$message.error("请上传AI格式或图片格式的文件！");
            return false;
          }
          this.interfaceAddress = "/declare/Upload/image";
          resolve();
        } else if (format === "ZIP") {
          if (
            file.type !== "application/x-zip-compressed" &&
            file.type !== "application/x-compressed" &&
            file.type !== "application/zip" &&
            file.type !== "application/x-rar-compressed" &&
            file.type !== "application/x-7z-compressed" &&
            file.type !== "application/x-tar" &&
            file.type !== "application/x-gzip" &&
            file.type !== "application/x-bzip2"
          ) {
            this.$message.error("请上传压缩包！");
            return false;
          }
          this.interfaceAddress = "/declare/Upload/upfile";
          resolve();
        }
        this.uploadCallback(true);
      });
    },
    handleUploadSuccess(res) {
      if (res.code == 1) {
        let isIDcard = false;
        if (this.idcardSurface !== "") {
          isIDcard = true;
          if (this.idcardSurface === "front") {
            this.idcardFrontAddress = res.data.uri;
          } else if (this.idcardSurface === "theback") {
            this.idcardTheBackAddress = res.data.uri;
          }
        } else {
          this.fileAddress = res.data.uri;
        }
        this.$message.success("上传成功");
        this.fileName = res.data.name;
        this.$emit("uploadSuccess", {
          address: res.data.uri,
          prop: this.prop,
          isIDcard,
          idcardSurface: this.idcardSurface,
          parentRef: this.parentRef,
        });
        this.idcardSurface = "";
        this.uploadCallback(false);
      } else {
        this.$message.error(res.msg);
        this.uploadCallback(false);
      }
    },
    handleUploadFail() {
      this.$message.error("上传失败！");
      this.uploadCallback(false);
    },
    handleClickUploadImg(flag) {
      this.idcardSurface = flag;
    },
  },
};
</script>

<style lang="scss" scoped>
#upload {
  position: relative;
}
.upload-wrapper {
  .el-upload__tip {
    margin-top: 0;
  }
  .upload-btn {
    width: 106px;
    height: 32px;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 6px;
    line-height: 32px;
    font-size: 14px;
    position: relative;
  }
  .upload-btn:hover {
    border-color: #e40080;
  }
  .upload-btn:focus {
    border-color: #e40080;
  }
  /deep/ .el-upload:focus {
    color: #000;
  }
}
.file {
  position: absolute;
  height: 32px;
  line-height: 32px;
  font-weight: 700;
  cursor: pointer;
  top: 2px;
  left: 124px;
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.idcard {
  display: flex;
  img {
    width: 210px;
    height: 138px;
    margin-right: 20px;
    cursor: pointer;
    object-fit: contain;
  }
}
</style>